/** @jsxRuntime classic */
/** @jsxFrag React.Fragment */
/** @jsx jsx */
import { ColumnsToExport, Dialog, ExpansiveArea, InfoSwatch, KeyWords } from '@bonitour/components'
import { jsx } from '@emotion/core'
import { useCallback, useState } from 'react'
import { customTooltipWrapper, customTooltip, customDialog } from './TransactionExportModal.styles'
import { useTransactionExport } from '../Hooks/useTransactionExport'

export function TransactionExportModal ({
  isVisible,
  toggleModal,
  transactionFilters = {}
}) {
  const [isMultiSelectOpened, setIsMultiSelectOpened] = useState(false)
  const [expandedFields, setExpandedFields] = useState({
    emails: false,
    columnsToExport: false
  })

  const {
    format,
    errors,
    onInputChange,
    onOptionChange,
    isChecked,
    onSelectAll,
    isSelectedAll,
    onExport,
    reset,
    exportOptions,
    columnsToExport,
    newEmail,
    setNewEmail,
    emails,
    handleEmails,
    isLoadingExport,
    isExpired,
    isStarted
  } = useTransactionExport(transactionFilters, toggleModal)

  const onModalClose = useCallback(() => {
    reset()
    toggleModal()
  }, [reset, toggleModal])

  const toggleExpanded = useCallback((field) => {
    setExpandedFields(prev => ({
      emails: false,
      columnsToExport: false,
      [field]: !prev[field]
    }))
  }
  , [setExpandedFields])

  return (
    <Dialog title='Configuração da exportação da tabela' isVisible={isVisible} onClose={onModalClose} customContainercss={[customDialog]}>
      <ColumnsToExport
        isMultiSelectOpen={isMultiSelectOpened}
        toggleMultiSelect={() => setIsMultiSelectOpened(prev => !prev)}
        multiSelectOptions={columnsToExport}
        isChecked={isChecked}
        onInputChange={onInputChange}
        format={format}
        errors={errors}
        onOptionChange={onOptionChange}
        allScheduleChange={onSelectAll}
        areAllSelected={isSelectedAll}
        formatOptions={exportOptions}
        onClick={onExport}
        loading={isLoadingExport || (isStarted && !isExpired)}
        isExpansiveColumnsToExport
        toggleExpanded={() => toggleExpanded('columnsToExport')}
        isExpandedColumnsToExport={expandedFields.columnsToExport}
      >
        <ExpansiveArea
          label={<>
            Email(s)
            <InfoSwatch tooltip='Você pode adicionar até 6 e-mails.' customTooltipWrapper={[customTooltipWrapper]} customTooltip={[customTooltip]}/>
          </>}
          isExpanded={expandedFields.emails}
          toggleExpanded={() => toggleExpanded('emails')}
          error={typeof errors?.emails === 'string' && errors?.emails}
        >
          <KeyWords
            keyWords={emails}
            setKeyWords={handleEmails}
            newKeyWord={newEmail}
            setNewKeyWord={setNewEmail}
            errors={errors?.emails}
            max={6}
            alreadyUsedKeyWordLabel={'Este e-mail já foi adicionado'}
          />
        </ExpansiveArea>
      </ColumnsToExport>
    </Dialog>
  )
}
